/**
 * How the named father or spouse is related, as an identity document prints it (owner, 2026-09-28:
 * "add relation type? for selection ex. son of, etc."). Stored in relation_type beside
 * father_or_spouse_name on farmers and workers (migration 700000).
 */
export const RELATION_TYPES = [
  { id: 'son_of', label: 'S/o - Son of' },
  { id: 'daughter_of', label: 'D/o - Daughter of' },
  { id: 'wife_of', label: 'W/o - Wife of' },
  { id: 'husband_of', label: 'H/o - Husband of' },
  { id: 'care_of', label: 'C/o - Care of' },
];

const SHORT: Record<string, string> = { son_of: 'S/o', daughter_of: 'D/o', wife_of: 'W/o', husband_of: 'H/o', care_of: 'C/o' };

/** "S/o Haripada Mondal"; just the name when the relation is not recorded. */
export function relationName(relation: string | null | undefined, name: string | null | undefined): string | null {
  if (!name?.trim()) return null;
  return relation && SHORT[relation] ? `${SHORT[relation]} ${name.trim()}` : name.trim();
}
